import '../scripts/polyfills';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import 'jquery.csssr.validation';
import menu from '../blocks/menu';
import tabs from '../blocks/tabs';
import questions from '../blocks/questions';
import {markIE} from './util/detect/detectIE';
import slider from '../blocks/slider';
import popup from '../blocks/popup';
import accord from '../blocks/accord';
import toggleAll from '../blocks/education/';
import showVideo from '../blocks/video-popup/';
import showMore from '../blocks/events/';
import userMenu from '../blocks/user-menu/';
import header from '../blocks/header/';
import mainAnim from '../blocks/main/';
import howToAnim from '../blocks/howto/';

$(() => {
	svg4everybody();
	menu();
	tabs();
	questions();
	markIE();
	slider();
	popup();
	accord();
	toggleAll();
	showVideo();
	showMore();
	userMenu();
	header();
	mainAnim();
	howToAnim();
});



// WEBPACK FOOTER //
// ./app/scripts/app.js